export default __webpack_public_path__ + "img/edit-small.d5c06d19.svg";